import Image from "components/Image"
import richText from "utilities/richText"

export default function InlineLogoAndContent({ blok }) {
  return (
    <div className="flex flex-col gap-7 prose-img:my-2 lg:flex-row lg:justify-center">
      <Image
        src={blok.logo.filename}
        alt={blok.logo.alt}
        className="lg:max-h-[125px] lg:w-auto"
        placeholder={blok.logo?.blurDataURL ? "blur" : "empty"}
        blurDataURL={blok.logo?.blurDataURL}
        width={250}
        height={250}
      />
      <div className="prose lg:self-center">{richText(blok.content)}</div>
    </div>
  )
}
